import ModelTrainingFormContext from './context';

const useModelTrainingFormContext = () => ModelTrainingFormContext.hook();

export default useModelTrainingFormContext;
